import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { asset, part, partCategory, quotation } from "../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext.jsx";
import { QRCode } from "react-qrcode-logo";
import {
  dateToToday,
  formatDateOnly,
  generateLocationToArray,
  printLocation,
} from "../../utils/helper.jsx";
import { useDashboardContext } from "../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import ConfirmationDlg from "../../components/ConfirmationDlg/index.jsx";
import { Loader } from "../../utils/helper";
import DataTable from "react-data-table-component";
import { LocationFilter } from "../../components/LocationFilter/index.jsx";
import ImageViewer from "../../components/ImageViewer";
import { format } from "date-fns";
import { PermissionChecker } from "../../components/PermissionChecker";

function QuotationList() {
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState({ page: 1,take:10,totalData:1 });
  const { config } = useAuth();
  const { machineTypes } = useDashboardContext();
  const [deleteRow, setDeleteRow] = useState(null);
  const [changeStatus, setChangeStatus] = useState(null);
  const [categories, setCategories] = useState([])
  const [confirmDlg, setConfirmDlg] = useState(false);
  const navigate = useNavigate();


  async function getData() {
    try {
      setLoading(true);
      const queryParam = {
        ...query,
      };
      const res = await quotation.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.results) {
          setDatas(data.results);
        }
        if (data.totalData) {
          setQuery((prev) => ({
            ...prev,
            totalData:data.totalData
          }))
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }


  function showConfirmationDlg(row) {
    setDeleteRow(row);
    setConfirmDlg(true);
  }
 


  function hideConfirmationDialog() {
    setDeleteRow(null);
  }


  async function deleteData() {
    try {
      const response = await quotation.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("This purchase order has been deleted");

          setDeleteRow(null);
          await getData()
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      minWidth: "150px",
    },
    {
      name: "Quotation Number",
      selector: (row) => "Quotation#"+row.number,
    },
  
    {
      name: "Created By",
      selector: (row) => row.created_by?.firstname,
    },
    {
      name: "Created At",
      selector: (row) =>  format(new Date(row.created_at),'yyyy-MM-dd'),
    },
    {
      name: "Status",
      selector: (row) => row.status == 'new' ? 'Waiting for Approval' : row.status,
      cell: (row) => (
        <span
          className={`badge border ${
            row.status === "new"
              ? "border-default text-default"
              : row.status === "approved"
              ? "border-theme text-theme"
              : row.status === "fulfilled"
              ? "border-warning text-warning"
              : "border-danger text-danger"
            }`}
          style={{textTransform:'capitalize'}}
        >
         {row.status == 'new' ? 'Waiting for Approval' : row.status}
        </span>
      ),
    },
    {
      name: "Action",
      minWidth: "300px",
      cell: (row) => (
        <div className="d-flex">
          <button
            style={{marginRight:10}}
            className="btn btn-sm btn-outline-theme mr-2"
            onClick={() => {
              navigate(`/quotation/detail/${row.id}`);
            }}
          >
            View
          </button>
        {row.status !='fulfilled' && <button
            style={{marginRight:10}}
            className="btn btn-sm btn-outline-warning ml-2"
            onClick={() => {
              navigate(`/quotation/edit/${row.id}`);
            }}
          >
            Edit
          </button>}     

          <button
            style={{marginRight:10}}
            className="btn btn-sm btn-outline-info mr-2"
            onClick={() => {
              navigate(`/quotation/duplicate/${row.id}`);
            }}
          >
            Duplicate
          </button>

          <PermissionChecker permissions={["delete quotation"]} hideIfNotAllowed>
          <button
            className="btn btn-sm btn-outline-danger ml-2"
            onClick={() => {
              showConfirmationDlg(row);
            }}
          >
            Delete
            </button>
            </PermissionChecker>
        </div>
      ),
    },
  ];



  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [query.page,query.take]);


  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">PART</a>
            </li>
            <li className="breadcrumb-item active">QUOTATION LIST</li>
          </ul>

          <h1 className="page-header">Quotation List</h1>

          <hr className="mb-4" />

          <div id="datatable" className="mb-5">
            <div className="row mb-2 justify-content-sm-end">

            
              <div className="col-sm-3 mb-2 mb-sm-0">
                <button
                  onClick={() => {
                    navigate("/quotation/add");
                  }}
                  className="btn btn-outline-theme w-100"
                >
                  Add Quotation <i className="bi bi-plus"></i>
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Card>
                  <CardBody>
               
                      <DataTable
                        progressPending={loading}
                        onRowClicked={(row) => {  navigate(`/quotation/detail/${row.id}`); }}
                        highlightOnHover
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                        pointerOnHover
                        paginationServer
                        onChangeRowsPerPage={(row)=>setQuery((prev)=>({...prev,page:1,take:row}))}
                        paginationTotalRows={query.totalData}
                        onChangePage={(page)=>setQuery((prev)=>({...prev,page:page}))}
                        
                      />
                
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>

      {deleteRow && (
        <ConfirmationDlg
          title={"Delete Quotation"}
          open={!!deleteRow}
          onClose={hideConfirmationDialog}
          onSubmit={deleteData}
        >
          <p style={{ pb: 2 }}>
            Are you sure you want to delete this quotation{" "}
            <strong>{deleteRow.name}</strong> ?
          </p>
        </ConfirmationDlg>
      )}
   
    </div>
  );
}

export default QuotationList;
